<template>
    <div class="card">
        <div class="card-header" :id="'card-heading-' + this._uid">
            <h5 class="mb-1 mt-2">
                <div class="btn-link" :data-target="'#card-target-' + this._uid" aria-expanded="true" :aria-controls="'card-target-' + this._uid">
                    <a v-if="headerLink" :href="headerLink" v-html="header" class="d-flex"></a>
                    <span v-else v-html="header"></span>
                </div>
            </h5>
        </div>

        <div v-if="hasCardBody" :id="'card-target-' + this._uid" :class="setCardClasses()" :aria-labelledby="'card-heading-' + this._uid" data-parent="#accordion">
            <div class="card-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            header: { type: String, required: true },
            headerLink: { type: String, required: false, default: '' }
        },

        data() {
            return {
                isOpen: true
            }
        },

        computed: {
            hasCardBody() {
                return !!this.$slots.default
            }
        },

        methods: {
            toggleCard() {
                this.isOpen = !this.isOpen;
            },

            setIconClasses() {
                return this.isOpen ? 'ico-close' : 'ico-open';
            },

            setCardClasses() {
                return this.isOpen ? 'collapse show' : 'collapse';
            }
        }
    }
</script>

<style lang="scss" scoped>
    $primary-color: #4e725b;

    .card {
        border-radius: 0;
        background-color: transparent;
        border:0;
        border-bottom:1px dotted #dac9be !important;
        margin-bottom:0 !important;

        .card-header {
            padding:.75rem 0;
            color: #000;
            background:transparent;
            border:0;

            h5 {
                color: #000;
                margin: 0;
                font-size: 1.5rem;
                line-height: 2rem;
                cursor: pointer;
                border:0;

                a {
                    font-weight: normal;
                    align-items: start;

                    &::v-deep .search-result-type {
                        
                        min-width: 80px;
                        margin-top: -4px;

                        .index-name {
                             display: inline-block;
                             white-space: nowrap;
                             border: 1px solid #ddd;
                             padding: 3px 6px;
                             color: #888;
                             line-height: 1;
                             font-size: 0.9rem;
                         }
                    }

                }
            }

            i {
                color: $primary-color !important;
                margin: 0 0.5rem 0 0;
            }

            .btn-link {
                font-weight: 600;
                color: #000;
                text-decoration: none;
            }
        }

        .card-body {
            font-size: 1.1rem;
            padding: 0.5rem 0 0.5rem 3rem !important;

            h3 {
                font-variant: small-caps;
                font-weight:600;
                margin: 0 0 10px 0px;
                font-size: 1.25rem;
                letter-spacing:0.075rem;
            }

            a > i {
                font-weight: 600;
            }

            small {
                font-size:1rem;
                font-family:Arial, sans-serif;
                font-weight:600;
            }

            a.search-result-divisions-link {
                position: relative;
                text-decoration: none;
                display: inline-block;
                overflow: hidden;
                color:#000 !important;
                
                &:hover {
                    text-decoration: none !important;
                    color: #76291f !important;
                }
            }

            ul {
                list-style: none;
                padding-left: 1rem;
                margin-bottom: 25px;
               
                li {
                    a {
                        color: $primary-color;
                        padding-left:0;
                    }
                }
            }
        }
    }
</style>